<template>
  <Card
    noBorder
  >
    <div
      v-if="!addOnIsEmpty"
      :class="$style.container"
      data-test-id="LatestActionCard__container"
    >
      <Icon
        data-test-id="LatestActionCard__addOnIcon"
        :icon="addOnIcon"
        :scale="4"
      />
      <div
        :class="$style.addOnDetails"
        data-test-id="LatestActionCard__addOnDetails"
      >
        <div :class="$style.toCart">
          <Icon
            :class="addOnWasAdded ? $style.added : $style.removed"
            icon="checkmarkCircle"
            :inline="true"
            :scale="1.25"
          />
          <HeadingExtraSmall>
            {{ addOnWasAdded ? 'Added to' : 'Removed from' }} Cart
          </HeadingExtraSmall>
        </div>
        <div :class="$style.attribute">
          {{ addOn.displayName }}
        </div>
        <div :class="$style.attribute">
          ${{ price }}/user/mo
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import {
  Card,
  HeadingExtraSmall,
  Icon,
} from '@jumpcloud/ui-components';
import { mapGetters } from 'vuex';
import SubscriptionConstants from 'client/Payments/pricingMatrix/SubscriptionConstants';

const pricingModule = 'PricingModule';
const checkoutModel = 'CheckoutModel';

const {
  AddOnStates,
} = SubscriptionConstants;

export default {
  name: 'LatestActionCard',

  components: {
    Card,
    HeadingExtraSmall,
    Icon,
  },

  data() {
    return {
      addOn: null,
    };
  },

  computed: {
    ...mapGetters(pricingModule, {
      subscriptionIsAnnual: 'getIsAnnual',
    }),

    ...mapGetters(checkoutModel, {
      latestAddOnChange: 'getLatestAddOnChange',
    }),

    addOnIcon() {
      if (this.addOnIsEmpty) {
        return '';
      }
      return this.addOn.icon;
    },

    addOnIsEmpty() {
      return !this.addOn;
    },

    addOnWasAdded() {
      return !this.addOnIsEmpty && this.addOn.changeType === AddOnStates.add;
    },

    price() {
      if (this.addOnIsEmpty) {
        return 0;
      }
      return this.getAddOnPrice(this.addOn);
    },
  },

  watch: {
    latestAddOnChange: {
      handler(newValue) {
        // Value is null when subscription is unset. This closes the cart, but
        // we want to continue displaying the last add on change as it closes
        if (!newValue) return;

        this.addOn = newValue;
      },
      immediate: true,
    },
  },

  methods: {
    getAddOnPrice(addOn) {
      return this.subscriptionIsAnnual ? addOn.annualPrice : addOn.listPrice;
    },
  },
};
</script>

<style module scoped>
.added {
  color: var(--jc-color-success-base);
}

.addOnDetails {
  display: flex;
  flex-direction: column;
}

.attribute {
  margin-top: var(--jc-spacer-x-small);
  text-align: left;
}

.container {
  align-items: center;
  display: flex;
  gap: var(--jc-spacer-large);
  height: 100%;
  justify-content: center;
}

.removed {
  color: var(--jc-color-error-base);
}

.toCart {
  display: flex;
}
</style>
